import type { ReactNode } from "react";

import { Stack } from "@similarweb/ui-components/foundations";

import ListPageHeader from "app/pages/sales-intelligence/common-components/header/ListPageHeader/ListPageHeader";
import {
    PageInnerContainer,
    StyledPageContainer,
} from "app/pages/sales-intelligence/common-components/layout/page-styles";
import { useSignalRecommenderFilesQuery } from "app/pages/sales-intelligence/modules/signal-recommender/query/queries/useSignalRecommenderFilesQuery";

import { SignalRecommenderBanner } from "../SignalRecommenderBanner/SignalRecommenderBanner";

type Props = {
    children: ReactNode;
};

const ManageSignalAnalysisPage = ({ children }: Props) => {
    const { data } = useSignalRecommenderFilesQuery();

    const hasNoAnalysisHistory = data?.files.length === 0;

    return (
        <StyledPageContainer data-automation="signal-analysis-page">
            <PageInnerContainer>
                <Stack gap="24px">
                    <ListPageHeader
                        title={{ key: "si.pages.signal-recommender.deal-signal-analysis" }}
                        description={{ key: "si.pages.signal-recommender.subtitle" }}
                    />

                    {hasNoAnalysisHistory ? <SignalRecommenderBanner /> : null}

                    {children}
                </Stack>
            </PageInnerContainer>
        </StyledPageContainer>
    );
};

export default ManageSignalAnalysisPage;
